export enum ShipmentSpecialFreightManagerEndpoint {
  Base = '/shipments',
  SpecialFreights = '/special-freights',
  Summary = '/summary',
  Milestones = '/milestones',
  Map = '/map',
  Notifications = '/notifications',
  Count = '/count',
}
